export const editRentRoomBuildingUrl = (propertyId: number): string =>
  `${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_BKK}/rent_room_buildings/${propertyId}/edit`;

export const editRentRoomUrl = (propertyId: number): string =>
  `${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_BKK}/rent_rooms/${propertyId}/edit`;

export const editRentParkingSpaceUrl = (propertyId: number): string =>
  `${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_BKK}/rent_parking_spaces/${propertyId}/edit`;
